import { render, staticRenderFns } from "./ColorListing.vue?vue&type=template&id=e452c568&scoped=true"
import script from "./ColorListing.vue?vue&type=script&lang=js"
export * from "./ColorListing.vue?vue&type=script&lang=js"
import style0 from "./ColorListing.vue?vue&type=style&index=0&id=e452c568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e452c568",
  null
  
)

export default component.exports